<template>
  <InvitationHeader />
  <div class="login_start">
    <InvitationProfileinfo />
    <DeclarationSection />
  </div>
  <Copyright />
</template>

<script>
import DeclarationSection from '@/components/Declaration'
import Copyright from '@/components/copyright.vue'
import InvitationHeader from '@/components/InvitationHeader'
import InvitationProfileinfo from '@/components/InvitationProfileinfo'

export default {
  name: 'signDeclaration',
  components: {
    InvitationHeader,
    InvitationProfileinfo,
    DeclarationSection,
    Copyright,
  },
}
</script>
